/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const nprogress = require('nprogress');

module.exports = {
	start: ()=> {
		nprogress.set(0.5)
  	nprogress.start()
	},
	end: ()=> {
		nprogress.done()
	}
}



// WEBPACK FOOTER //
// ./src/common/utils/spinner.js